exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-right {\r\n    float: right;\r\n}\r\n\r\n.interactive {\r\n    position: relative;\r\n    width:24px; height:24px;\r\n    -webkit-transition: color 0.25s;\r\n    transition: color 0.25s;\r\n}\r\n\r\n.interactive:hover {\r\n    cursor: pointer;\r\n    color: #AAAAAA;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/link/link.component.css
// module id = ../../../../../src/app/generator/link/link.component.css
// module chunks = main